import { createIcon } from "@chakra-ui/icons";

const ChevronUp = createIcon({
  displayName: "ChevronUp",
  viewBox: "0 0 24 24",
  path: [
    <path
      d="M18 15L12 9L6 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      key="c_jQ"
    ></path>,
  ],
  defaultProps: { boxSize: 4 },
});

export default ChevronUp;
